import { useMutation, useQueryClient } from "@tanstack/react-query";
import { axiosInstance } from "@/helpers/axios";
import type { ApiResponse } from "@/helpers/axios";
import type { ApiAsset } from "../_types/assets.types";

const duplicateFileName = (name: string): string => {
  const i = name.lastIndexOf(".");
  if (i <= 0) return `${name} (copy)`;
  return `${name.slice(0, i)} (copy)${name.slice(i)}`;
};

export const useDuplicateAssetMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (asset: ApiAsset) => {
      const fileRes = await axiosInstance.get(`/v2/assets/${asset.id}/file`, {
        responseType: "blob",
      });
      const blob = fileRes.data as Blob;
      const name = duplicateFileName(asset.name);
      const file = new File([blob], name, { type: asset.mimeType });
      const form = new FormData();
      form.append("file", file);
      form.append("name", name);
      const response = await axiosInstance.post<ApiResponse<ApiAsset>>(
        "/v2/assets",
        form,
        {
          headers: { "Content-Type": "multipart/form-data" },
        },
      );
      if (!response.data.success || !response.data.data) {
        throw new Error(response.data.message ?? "Duplicate failed");
      }
      return response.data.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["assets"] });
    },
  });
};
